import 'arrive';
import Swiper from 'swiper/bundle';

document.arrive('.block-advantages', { existing: true }, function (el) {
  const container = el.querySelector('.block-advantages__grid.swiper');
  if (!container || container.dataset.swiperInitialized === 'true') return;

  // Mark as initialized to avoid duplicates
  container.dataset.swiperInitialized = 'true';

  // On mobile, turn grid into slider with 1.2 slides per view and no effect
  const swiper = new Swiper(container, {
    slidesPerView: 1.15,
    spaceBetween: 24,
    loop: false,
    freeMode: true,
    allowTouchMove: true,
    breakpoints: {
        1080: {
            slidesPerView: 5,
            spaceBetween: 24,
        },
        800: {
            slidesPerView: 3.8,
            spaceBetween: 24,
        },
        700: {
            slidesPerView: 3.2,
            spaceBetween: 24,
        },
        600: {
            slidesPerView: 2.8,
            spaceBetween: 24,
        },
        550: {
            slidesPerView: 2.2,
            spaceBetween: 24,
        },
    },
  });
});